export default {"src":"/_next/static/media/our-services-bank.71aeea63.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};